import { render, staticRenderFns } from "./PlanComparing.vue?vue&type=template&id=f6c2221c&lang=pug"
import script from "./PlanComparing.vue?vue&type=script&lang=js"
export * from "./PlanComparing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GroupPlanCompare: require('/home/docker/code/frontend/components/GroupPlanCompare.vue').default,PlanCompare: require('/home/docker/code/frontend/components/PlanCompare.vue').default})
